import React, { memo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Picture } from 'components';
import { Text } from '@beef/ui-kit';

// Styles
import styles from '../../styles.pcss';
const cn = classNames.bind(styles);

export const MainContent = memo(({ image, header, message }) => (
  <>
    {image && (
      <div className={cn('error__icon-wrapper')}>
        <Picture
          className={cn('error__icon')}
          defaultImage={image}
          alt="Ошибка"
        />
      </div>
    )}
    {header && (
      <div className={cn('error__title')}>
        <Text size="size2-m">{header}</Text>
      </div>
    )}
    {message && (
      <div className={cn('error__description')}>
        <Text color="grey50" size="size5-r-s">{message}</Text>
      </div>
    )}
  </>
));

MainContent.propTypes = {
  image: PropTypes.string,
  header: PropTypes.string,
  message: PropTypes.string,
};
